import { GitBranch, Github } from 'lucide-react';
import { parseRepoRemote } from '../../lib/ctoReviews';

export function RepoMark({
  repo,
  iconClassName = 'h-4 w-4',
}: {
  repo: string;
  iconClassName?: string;
}) {
  const parsed = parseRepoRemote(repo);
  const Icon = parsed.host === 'github' ? Github : GitBranch;
  return (
    <span className="inline-flex items-center gap-1.5 min-w-0">
      <Icon className={`${iconClassName} shrink-0`} aria-hidden />
      <span className="font-mono font-medium truncate">{parsed.path}</span>
    </span>
  );
}

export function RepoHoverCard({
  repo,
  facts = [],
}: {
  repo: string;
  facts?: string[];
}) {
  const parsed = parseRepoRemote(repo);
  return (
    <div
      role="tooltip"
      className="pointer-events-none absolute left-1/2 top-full z-40 mt-2 w-max max-w-sm -translate-x-1/2 rounded-xl border border-gray-700 bg-gray-900 px-3.5 py-2.5 text-left text-sm text-white opacity-0 shadow-lg invisible transition-opacity group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100"
    >
      <p className="font-semibold">
        {parsed.host === 'github' ? 'GitHub repo' : 'Repository'}
      </p>
      <p className="mt-1 font-mono text-sm leading-snug text-gray-200 break-all">
        {parsed.fullPath}
      </p>
      {facts.map((fact) => (
        <p key={fact} className="mt-1.5 text-gray-300">
          {fact}
        </p>
      ))}
    </div>
  );
}

export function RepoChip({
  repo,
  facts,
  children,
}: {
  repo: string;
  facts?: string[];
  children: React.ReactNode;
}) {
  return (
    <span className="relative inline-flex group">
      {children}
      <RepoHoverCard repo={repo} facts={facts} />
    </span>
  );
}
